const newEquipmentType = {
  snackbar: "Su actualización esta completada",
  name: "Tipo de Activo",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Cliente",
  formTitle: "Nuevo Tipo de Activo",
  isPump: "¿Es una bomba?",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newEquipmentType;
